<template>
  <div class="course-content">
    <Title name="课程日历"></Title>
    <div class="recently-box">
      <el-calendar class="course-calender" v-model="calender">
        <template slot="dateCell" slot-scope="{ data, date}">
          <p :class="[monthData.list[data.day] && monthData.list[data.day].num > 0 ? 'is-course' : '' , data.isSelected &&  'is-selected']">
            {{ currentDate == data.day ? '今' : data.day.split("-")[2] }}
          </p>
        </template>
      </el-calendar>
      <p class="divider"></p> 
      <div class="that-day-all">
        <div class="that-day-header current-course-num">
          <p>
            当天有<span>{{ monthData.currentData.num || 0}}节</span>课
          </p>
          <div class="that-day-status">
            <p v-for="item in attendedNav" :key="item.key" :class="{active: currentCalenderCourseStatus == item.key}" @click="() => {currentCalenderCourseStatus = item.key}">
              {{item.name}}
            </p>
          </div>
        </div>
        <div class="that-day-body" v-if=" monthData.currentData.num > 0">
          <div
            v-for="(item, index) in monthData.currentData.courses"
            :key="index"
            @click="traingClick(item.id, item.type)"
          >
            <div class="carousel-item that-day-item that-day-tiem-flex" v-if="currentCalenderCourseStatus == 2 || currentCalenderCourseStatus == item.attended">
              <div>
                <p class="carousel-item-title">
                  <span v-if="item.attended" class="attended-icon have-attended-icon calender-attended-icon">已出勤</span>
                  <span v-else class="attended-icon no-attended-icon calender-attended-icon">未出勤</span>
                  <span class="title">{{ item.title }}</span>
                </p>
                <p class="carousel-item-subtitle">
                  <span>{{ item.startTime }}-{{ item.endTime }}</span>
                  &nbsp; | &nbsp;
                  <span>{{ item.type == 1 ? "训练营" : "系列课" }}</span>
                  &nbsp; | &nbsp;
                  <span v-if="item.type == 2">第{{ item.unitIndex }}章</span>
                  <span v-else>第{{ item.days }}天</span>
                </p>
              </div>
              <div>
                <el-button type="danger" size="mini" v-if="item.courseStatus == 1" round plain>直播中</el-button>
                <el-button type="primary" size="mini" v-if="item.courseStatus == 2" round plain>有重播</el-button>
                <el-button type="info" size="mini" v-if="item.courseStatus == 0" round plain>未开始</el-button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="that-day-body">
          <noData title="当天暂无课程"></noData>
        </div>
      </div>
      
      <!-- <el-dialog
        :visible.sync="calenderVisible"
        top="5vh"
        width="882px"
        id="course-dialog"
      >
        <template slot="title">
          <Title name="全部课程"></Title>
        </template>
        
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog> -->
    </div>
    <Title name="我的课程"></Title>
    <div class="course-list" v-if="courseList.length > 0">
      <div
        class="course"
        v-for="(item, index) in courseList"
        :key="index"
        v-if="
          (item.unitList && item.unitList.length > 0) ||
            (item.courseList && item.courseList.length > 0)
        "
      >
        <div class="course-time">
          <img
            class="icon-time"
            src="../../assets/images/icons/icon-time.png"
          />
          <div class="txt-time">{{ item.durationTime }}</div>
        </div>
        <div class="course-intro">
          <img v-if="item.poster" class="cover" :src="item.poster" />
          <img
            v-else
            class="cover"
            src="../../assets/images/default-course.png"
          />
          <div class="course-info">
            <div class="top">
              <div class="course-title">
                <div class="course-name">{{ item.name }}</div>
                <div class="course-count">（共计{{ item.courseNum }}课时）</div>
              </div>
            </div>
            <div class="teacher-info">
              <img class="teacher-head" :src="item.teacherAvatar" />
              <div class="teacher-name">主讲老师：{{ item.teacherName }}</div>
            </div>
            <div
              class="button"
              v-if="item.courseList && item.courseList.length > 0"
              @click="goClass(item)"
            >
              去上课
            </div>
          </div>
        </div>
        <div class="course-txt-line">课程大纲</div>
        <div class="course-main" v-if="item.type === 1">
          <div
            class="course-chapter-list"
            v-for="(aItem, aIndex) in item.courseList"
            :key="aIndex"
          >
            <div class="course-chapter-list-l">
              <div
                class="course-chapter"
                :class="{ living: aItem.course_status == 1 }"
                @click="traingClick(aItem.id, item.type)"
              >
                <span
                  v-if="aItem.attended"
                  class="have-attended-icon attended-icon"
                  >已出勤</span
                >
                <span v-else class="no-attended-icon attended-icon"
                  >未出勤</span
                >
                <div
                  class="icon-video"
                  :class="{
                    live:
                      (aItem.course_type === 2 || aItem.course_type === 3) &&
                      aItem.course_status === 0
                  }"
                ></div>
                <div class="txt-name">{{ aItem.course_name }}</div>
              </div>
              <div
                class="course-duration-time"
                v-if="aItem.course_status === 0"
              >
                开课时间：{{ aItem.startTime }}
              </div>
              <div
                class="course-duration-time"
                v-else-if="aItem.course_status === 2"
              >
                课程时长：{{ aItem.timeDuration }}
              </div>
            </div>
            <div class="course-data">
              <span v-if="aItem.assignment_id !== 0" class="icon-task" @click="openCourseData(2, aItem.id, aItem.assignment_id, aItem.course_name, aItem.course_status, 1)">作业</span>
              <span
                v-if="aItem.hasMaterials === 1"
                class="icon-data"
                @click="openCourseData(3, aItem.id, 1)"
                >资料</span
              >
            </div>
          </div>
        </div>
        <div class="course-main series-course" v-if="item.type === 2">
          <div
            class="chapter-box"
            v-for="(bItem, bIndex) in item.unitList"
            :key="bIndex"
            v-if="bIndex < 5 || item.showChapter"
          >
            <div class="chapter-title">
              <div class="txt" @click="chapterLookHandler(index, bIndex)">
                {{ bItem.unitName }}
              </div>
              <div
                class="up"
                v-if="bItem.checked"
                @click="chapterLookHandler(index, bIndex)"
              >
                收起
              </div>
              <div
                v-else
                class="down"
                @click="chapterLookHandler(index, bIndex)"
              >
                展开
              </div>
            </div>
            <el-collapse-transition>
              <div class="chapters-list" v-if="bItem.checked">
                <div
                  class="course-chapter-list"
                  v-for="(mItem, mIndex) in bItem.courseList"
                  :key="mIndex"
                >
                  <div class="course-chapter-list-l">
                    <div
                      class="course-chapter"
                      :class="{ living: mItem.course_status === 1 }"
                      @click="traingClick(mItem.id, item.type)"
                    >
                      <span
                        v-if="mItem.attended"
                        class="have-attended-icon attended-icon"
                        >已出勤</span
                      >
                      <span v-else class="no-attended-icon attended-icon"
                        >未出勤</span
                      >
                      <div
                        class="icon-video"
                        :class="{
                          live:
                            (mItem.course_type === 2 ||
                              mItem.course_type === 3) &&
                            mItem.course_status === 0
                        }"
                      ></div>
                      <div class="txt-name">{{ mItem.course_name }}</div>
                    </div>
                    <div
                      class="course-duration-time"
                      v-if="mItem.course_status === 0"
                    >
                      开课时间：{{ mItem.startTime }}
                    </div>
                    <div
                      class="course-duration-time"
                      v-else-if="mItem.course_status === 2"
                    >
                      课程时长：{{ mItem.timeDuration }}
                    </div>
                  </div>
                  <div class="course-data">
                    <span v-if="mItem.assignment_id !== 0" class="icon-task" @click="openCourseData(2, mItem.id, mItem.assignment_id, mItem.course_name, mItem.course_status, 2)">作业</span>
                    <span
                      v-if="mItem.hasMaterials === 1"
                      class="icon-data"
                      @click="openCourseData(3, mItem.id, item.shuidiId, 2)"
                      >资料</span
                    >
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>
          <template v-if="item.unitList.length > 5">
            <div
              class="get-more-chapter"
              v-if="item.showChapter"
              key="up"
              @click="getMoreCourse(index)"
            >
              <div class="more">收起</div>
              <div class="icon up"></div>
            </div>
            <div
              class="get-more-chapter"
              v-if="!item.showChapter"
              key="down"
              @click="getMoreCourse(index)"
            >
              <div class="more">展开全部</div>
              <div class="icon down"></div>
            </div>
          </template>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :hide-on-single-page="true"
          layout="prev, pager, next"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>
    <div v-else class="no-data-list">
      <img
        class="no-data"
        src="//kandian-1254383113.file.myqcloud.com/cloud/pc/no-data-course-list.png"
      />
      <div class="no-data-txt">暂无课程安排</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { getCourseList, getCalender } from "../../server/course";
import { isStudy } from "../../utils/utils";
import {
  formDataTimeDay,
  formDataTimeMinutes,
  timeStamp
} from "../../utils/utils";
import moment from "moment";

import Title from "../../components/title";
import noData from "../../components/noData";
export default {
  name: "MyCourse",
  computed: {
    ...mapGetters(["userId"])
  },
  inject: ["reload"],
  components: {
    Title,
    noData
  },
  data() {
    return {
      pageCount: 10,
      totalNum: 0,
      currentMonth: 0,
      calenderVisible: true,
      calender: new Date,
      weekHead: ["一", "二", "三", "四", "五", "六", "日"],
      attendedNav: [
        {
          name: '全部',
          key: 2
        },
        {
          name: '未出勤',
          key: 0
        },
        {
          name: '已出勤',
          key: 1
        }
      ],
      currentCalenderCourseStatus: 2,
      courseList: [],
      currentDate: null,
      weekData: {
        currentData: {},
        list: {}
      },
      monthData: {
        currentData: {},
        list: {}
      }
    };
  },
  beforeMount() {
    let startTime = moment().startOf('month').format('YYYY-MM-DD')
    let endTime = moment().add(1, 'M').endOf('month').format('YYYY-MM-DD')
    this.currentDate = moment().format('YYYY-MM-DD')
    this.getCalender(2, startTime, endTime);
  },
  mounted() {
    this.getCourseList();
  },
  watch: {
    calender(newVal, oldVal) {
      let newMonth = moment(newVal).format('M')
      let oldMonth = moment(oldVal).format('M')
      let isRequest = newMonth - oldMonth
      if(isRequest != 0) {
        let startTime = moment(newVal).startOf('month').format('YYYY-MM-DD')
        let endTime = moment(newVal).add(1, 'M').endOf('month').format('YYYY-MM-DD')
        this.getCalender(2, startTime, endTime);
      }else {
        this.monthData.currentData = this.monthData.list[this.transferDate(newVal)];
      }
      this.currentCalenderCourseStatus = 2;
    }
  },
  methods: {
    /**
     * 获取本周课程
     */
    getWeek(callback) {
      // 按周日为一周的最后一天计算
      var date = new Date();
      // 今天是这周的第几天
      var today = date.getDay();
      //上周日距离今天的天数（负数表示）
      var stepSunDay = -today + 1;
      // 如果今天是周日
      if (today == 0) {
        stepSunDay = -7;
      }
      // 周一距离今天的天数（负数表示）
      var stepMonday = 7 - today;
      var time = date.getTime();
      var monday = new Date(time + stepSunDay * 24 * 3600 * 1000);
      var sunday = new Date(time + stepMonday * 24 * 3600 * 1000);
      // 本周一的日期 （起始日期）
      var startTime = this.transferDate(monday);
      // 本周日的日期 （结束日期）
      var endTime = this.transferDate(sunday);
      return callback(startTime, endTime) && callback;
    },

    /**
     * 获取当月的起止时间
     */
    getMonthStartAndEnd(callback, AddMonthCount) { 
      //获取当前时间  
      var currentDate = new Date();
      var month=currentDate.getMonth()+AddMonthCount;
      if(month<0){
        var n = parseInt((-month)/12);
        month += n*12;
        currentDate.setFullYear(currentDate.getFullYear()-n);
      }
      currentDate = new Date(currentDate.setMonth(month));
      //获得当前月份0-11  
      var currentMonth = currentDate.getMonth(); 
      //获得当前年份4位年  
      var currentYear = currentDate.getFullYear(); 
      //获得上一个月的第一天  
      var currentMonthFirstDay = this.transferDate(new Date(currentYear, currentMonth,1));
      //获得上一月的最后一天  
      var currentMonthLastDay = this.transferDate(new Date(currentYear, currentMonth+1, 0));
      return callback(currentMonthFirstDay, currentMonthLastDay) && callback
    },

    /**
     * 日期格式化
     */
    transferDate: function(date) {
      // 年
      var year = date.getFullYear();
      // 月
      var month = date.getMonth() + 1;
      // 日
      var day = date.getDate();

      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day >= 0 && day <= 9) {
        day = "0" + day;
      }

      var dateString = year + "-" + month + "-" + day;
      return dateString;
    },

    /**
     * 获取日历数据
     * @param { Number } type 1-周，2-月
     * @param { String } startTime 开始时间
     * @param { String } endTime 结束时间
     * @param { String } visibleDate 要展示的时间
     */
    async getCalender(type, startTime, endTime, visibleDate) {
      const { code, data, msg } = await getCalender({
        type: type,
        startTime: startTime,
        endTime: endTime
      });
      if (code === 0) {
        this.regroupDateInfo(data.list, type, visibleDate);
      } else {
        this.$message.error(msg);
      }
    },

    /**
     * 重组数据
     * @param { Array } data 后台返回日历数据
     * @param { Number } type 1-周，2-月
     * @param { String } visibleDate 要展示的时间
     */
    regroupDateInfo(data, type, visibleDate) {
      var date = new Date(),
          currentDay = this.transferDate(date);
      data.forEach(item => {
        if(type == 1) {
          this.weekData.list[item.date] = item;
          this.weekData.currentData = this.weekData.list[currentDay];
        }else {
          this.$set(this.monthData.list, item.date, item);
          // this.monthData.list[item.date] = item;
        }
      });
     
      if(type == 2) {
        this.monthData.currentData = this.monthData.list[visibleDate || currentDay];
      }
    },

    /**
     * 去直播间
     */
    traingClick(courseId, type, status) {
      const { href } = this.$router.resolve({
        name: "videoRoomChild",
        query: {
          type: type,
          courseId: courseId
        }
      });
      window.open(href, "_blank");
    },

    async getCourseList(curPage = 0) {
      const requestParams = {
        start: curPage,
        count: this.pageCount
      };
      const { code = 1, msg = "", ...res } = await getCourseList(requestParams);
      if (code === 0) {
        const { paginationList = [], totalNum } = res.data;
        this.totalNum = totalNum;
        // type: 课程类型 1-训练营 2-系列课
        for (let i = 0; i < paginationList.length; i++) {
          let item = paginationList[i];
          let startTime = formDataTimeDay(item.startTime);
          let endTime = formDataTimeDay(item.endTime);
          item.durationTime = `${startTime}-${endTime}`;
          item.type = parseInt(item.type);
          if (item.type === 2 && item.unitList.length > 5) {
            item.showChapter = false;
          } else {
            item.showChapter = true;
          }
          if (item.type === 1) {
            for (let j = 0; j < item.courseList.length; j++) {
              item.courseList[j].startTime = formDataTimeMinutes(
                item.courseList[j].start_time
              );
              if (item.courseList[j].course_status === 2) {
                let time = timeStamp(item.courseList[j].duration);
                if (parseInt(time.hour) > 0) {
                  item.courseList[
                    j
                  ].timeDuration = `${time.hour}时${time.min}分${time.second}秒`;
                } else {
                  item.courseList[
                    j
                  ].timeDuration = `${time.min}分${time.second}秒`;
                }
              }
            }
          } else if (item.type === 2) {
            for (let j = 0; j < item.unitList.length; j++) {
              item.unitList[j].checked = false;

              for (let m = 0; m < item.unitList[j].courseList.length; m++) {
                item.unitList[j].courseList[m].startTime = formDataTimeMinutes(
                  item.unitList[j].courseList[m].start_time
                );
                if (item.unitList[j].courseList[m].course_status === 2) {
                  let time = timeStamp(item.unitList[j].courseList[m].duration);
                  if (parseInt(time.hour) > 0) {
                    item.unitList[j].courseList[
                      m
                    ].timeDuration = `${time.hour}时${time.min}分${time.second}秒`;
                  } else {
                    item.unitList[j].courseList[
                      m
                    ].timeDuration = `${time.min}分${time.second}秒`;
                  }
                }
              }
            }
          }
        }
        this.courseList = paginationList;
      } else {
        this.$message({
          center: true,
          message: msg,
          type: "error"
        });
      }
    },
    handleCurrentChange(page) {
      const val = (page - 1) * this.pageCount;
      this.getCourseList(val);
    },
    chapterLookHandler(index, bIndex) {
      this.courseList[index].unitList[bIndex].checked = !this.courseList[index]
        .unitList[bIndex].checked;
      Vue.set(
        this.courseList[index].unitList,
        bIndex,
        this.courseList[index].unitList[bIndex]
      );
    },
    getMoreCourse(index) {
      this.courseList[index].showChapter = !this.courseList[index].showChapter;
    },
    goClass(item) {
      let courseId = "";
      if (item.type === 1) {
        courseId = item.courseList[0].id;
      } else if (item.type === 2) {
        courseId = item.unitList[0].courseList[0].id;
      }
      const { href } = this.$router.resolve({
        name: "videoRoomChild",
        query: {
          type: item.type,
          courseId: courseId
        }
      });
      window.open(href, "_blank");
    },
    /**
     * 进入课程资料或作业
     * @param { Number } type 1-随堂考 2-作业 3-资料
     * @param { Number } id 课程ID
     * @param { Number } stuId 学员ID
     * @param { Number } paperId 作业Id
     * @param { Number } status 课程状态
     * @param { Number } courseType 课程类型 1:训练营 2:系列课
     */
    openCourseData(type, id, paperId = "", courseName = "", status = 0, courseType) {
      const _this = this;
      if (status === 0 && type === 2) {
        _this.$message.warning("课程未开始, 暂时不能答题哦~");
        return;
      }
      let query = {};
      query.courseId = id;
      query.stuId = _this.courseId;
      query.courseType = courseType;
      if (type === 2) {
        query.paperId = paperId;
        query.name = courseName;
        const { href } = _this.$router.resolve({
          name: "question",
          query: query
        });
        window.open(href, "_blank");
      } else if (type === 3) {
        const { href } = _this.$router.resolve({
          name: "courseData",
          query: query
        });
        window.open(href, "_blank");
      }
    },

    /**
     * 选择本周课程
     * @param { Object } data 当前课程信息
     */
    handleWeek(data) {
      this.weekData.currentData = data;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" src="./scss/myCourse.scss"></style>



// WEBPACK FOOTER //
// src/views/course/myCourse.vue